import { SettingsIcon } from "@carbon6/c6-frontend-design";
import type { MouseEvent as ReactMouseEvent, ReactNode } from "react";
import styles from "./FilterSheetButton.module.css";

export type FilterSheetButtonProps = {
  // 라벨이다. 페이지 필터는 "고급 필터", 좁은 레인은 "필터" 다. 아이콘만 표시하도록 줄이지 않는다(§17).
  label: string;
  // 배지에 표시할 수다. **이 버튼을 눌러야 보이는** 조건의 수다. 0 이면 배지를 그리지 않는다.
  count: number;
  open: boolean;
  // 트리거 이벤트를 그대로 전달한다. 앵커드 팝오버를 쓰는 곳이 `openFromElement` 로 위치를 정한다.
  onOpen: (event: ReactMouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  className?: string;
};

/**
 * 접어 둔 필터 영역을 여는 진입 버튼이다. `⚙` + 라벨 + 바깥 조건 수 배지로 구성한다(rules.md §17).
 *
 * 무엇을 여는지는 사용하는 쪽이 정한다(데이터셋은 모달 시트, 에피소드 레인은 앵커드 팝오버).
 * 이 컴포넌트는 진입점의 시각 계약만 소유한다. 높이 2rem·좌우 1rem 은 c6 md 텍스트 컨트롤
 * 계약과 같다. 그래서 같은 줄의 검색(size 미지정 = md)과 높이가 같다. 라벨은 읽기 쉽도록 body 다.
 */
export function FilterSheetButton({
  label,
  count,
  open,
  onOpen,
  disabled = false,
  className,
}: FilterSheetButtonProps): ReactNode {
  return (
    <button
      type="button"
      className={className ? `${styles.trigger} ${className}` : styles.trigger}
      data-open={open ? "true" : undefined}
      aria-haspopup="dialog"
      aria-expanded={open}
      disabled={disabled}
      onClick={onOpen}
    >
      <SettingsIcon className={styles.icon} aria-hidden="true" />
      <span>{label}</span>
      {count > 0 ? <span className={styles.badge}>{count}</span> : null}
    </button>
  );
}
